import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUser(response.data);
      } catch (error) {
        // Solo cerrar sesión si el servidor rechaza el token (401/403).
        // Errores de red (dominio bloqueado, sin conexión) conservan la sesión.
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          localStorage.removeItem('token');
        }
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem('token', response.data.access_token);
    setUser(response.data.user);
    return response.data;
  };

  const register = async (email, password, nombre, fechaNacimiento = null, fotoPerfil = null, role = 'miembro') => {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('nombre', nombre);
    formData.append('role', role);
    if (fechaNacimiento) {
      formData.append('fecha_nacimiento', fechaNacimiento);
    }
    if (fotoPerfil) {
      formData.append('foto_perfil', fotoPerfil);
    }
    
    const response = await axios.post(`${API}/auth/register`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    localStorage.setItem('token', response.data.access_token);
    setUser(response.data.user);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const token = localStorage.getItem('token');

  const value = {
    user,
    setUser,
    login,
    register,
    logout,
    loading,
    token
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}